import React from "react";
import { createPortal } from "react-dom";

const ModalWrapper = ({
  isShow = false,
  setIsShow,
  children,
  okMsg,
  ...props
}) => {
  const handleClose = () => {
    setIsShow(false);
  };

  return createPortal(
    <div
      id="static-modal"
      className={`fixed top-0 left-0 w-full h-full flex items-center justify-center  bg-opacity-50 ${
        !isShow ? "hidden" : ""
      }`}
    >
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl">
        {/* Modal header */}
        <div className="flex items-center justify-between p-2 md:pt-2 pb-1 rounded-t">
          <button
            type="button"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="static-modal"
            onClick={handleClose}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
        </div>
        {/* Modal body */}
        <div className="pb-4">{children}</div>
        {/* Modal footer */}
        <div className="flex items-center p-1 md:p-2 border-t border-gray-200 rounded-b">
          <button
            data-modal-hide="static-modal"
            type="button"
            className="bg-gradient-to-l from-[#ff6f00] to-[#ff9100] px-2 py-1 rounded text-sm text-white no-underline ml-4"
            onClick={props?.okFun || handleClose}
          >
            {okMsg || "I Accept"}
          </button>
          {/* <button
            data-modal-hide="static-modal"
            type="button"
            className="py-1 px-2 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded border border-gray-200 hover:bg-gray-100 hover:text-orange-400 focus:z-10 focus:ring-4 focus:ring-gray-100"
            onClick={handleClose}
          >
            Decline
          </button> */}
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default ModalWrapper;
